<template>
  <div class="panel-content" v-if="currItem.screen_text">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>
    <div class="example" v-if="!isSPC">
      {{ currItem.is_example ? $t("hsk_example") : currItem.index }}
    </div>
    <!-- 答题区域 -->
    <div class="panel-content-answer">
      <div v-for="(item, index) in textQues" :key="index">
        <div class="answer-text" v-if="!item.blank" :style="{marginLeft: item.margin == 0 ? '0px' : '10px'}">
          <PhoneticText :showPinyin="true" :originData="item.pytext" :baseStyles="textBlackStyles"></PhoneticText>
        </div>
        <div class="pinyin-box" v-if="item.blank == 'input'">
          <div class="pinyin-text">{{ item.pinyin }}</div>
          <div
            :class="[
              'input-box',
              {
                success: !isExamMode && inputAnswers[item.index].correct,
                error: !isExamMode && !inputAnswers[item.index].correct,
              },
            ]"
          >
            <!-- {{inputAnswers[item.index]}} -->
            <input
              type="text"
              :maxlength="item.width"
              v-model="inputAnswers[item.index].text"
              @change="textInput($event, item.index)"
              :disabled="!isExamMode || currItem.is_example"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 结果提示 -->
    <div class="panel-content-result result-correct" v-if="!isExamMode && isCorrect && !currItem.is_example">
      <p class="correct-tips">
        {{ $t("textbook_chioce_word_text_correct_tip") }}
      </p>
      <div class="correct-box" v-show="analysisText">
        <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
        <p class="correct-box-answer">
          {{ analysisText }}
        </p>
      </div>
    </div>

    <div class="panel-content-result result-error" v-if="!isExamMode && !isCorrect && !currItem.is_example">
      <p class="error-tips">
        {{ $t("textbook_chioce_word_text_error_tip") }}
      </p>
      <div class="result-show">
        <p class="your-answer">{{ $t("hsk_your_answer") }}{{ currItem.answer }}</p>
        <p class="correct-answer">
          {{ $t("hsk_correct_answer") }}<span>{{ correctAnswers }}</span>
        </p>
      </div>
      <div class="correct-box" v-show="analysisText">
        <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
        <p class="correct-box-answer">
          {{ analysisText }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const parser = new DOMParser();
import { renderScreenText } from "@/utils/utils";
import QuestionDescription from "@/components/hsk/questionDescription";
import PhoneticText from "@/components/ui/phoneticText";
export default {
  components: { QuestionDescription, PhoneticText},
  data() {
    return {
      // 试题数组
      items: [],
      // 当前小题Index
      currIndex: 0,
      blankType: "",
      correctAnswers: "",
      textQues: [],
      // 当前小题填空项
      inputAnswers: [],
      // 是否已经提交
      isSubmit: false,
      // 禁止点击
      isDisabled: false,

      changeBtn: false,
    };
  },
  computed: {
    //初始黑色
    textBlackStyles() {
      return {
        // 拼音文本初始颜色
        originPinyinColor: "#3F4651",
        // 拼音文本字体大小
        pinyinFontSize: "10px",
        // 拼音文本 行高
        pinyinLineHeight: "14px",
        // 汉字文本初始颜色
        originHzColor: "#3E4651",
        // 拼音文本字体大小
        hzFontSize: "16px",
        // 汉字文本 行高
        hzLineHeight: "16px",
        // 行文 间距(下方间距)
        writingSpacing: "0px",
        // 分词间距
        wordSpacing: "10px",
      };
    },
    textStyles() {
      return {
        wordSpacing: "10px",
        hzFontSize: "16px",
        color: "#3F4651",
        writingSpacing: "0px",
      };
    },
    language() {
      let local = localStorage.getItem("language");
      if (local == "zh") {
        return "cn";
      } else {
        return local;
      }
    },
    analysisText() {
      return this.currItem.analysis[this.language]
        ? this.currItem.analysis[this.language]
        : this.currItem.analysis["cn"];
    },
    // 当前小题是否作答成功
    isCorrect() {
      let correct = true;
      for (let i = 0; i < this.inputAnswers.length; i++) {
        if (!this.inputAnswers[i].correct) {
          correct = false;
          break;
        }
      }
      return correct;
    },
  },
  watch: {
    currItem: {
      handler(val) {
        if (val && val.screen_text) {
          this.textQues = renderScreenText(val.screen_text[0].content);
          this.setInputAnswers(val);
        }
      },
      immediate: true,
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    isSPC: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    // 设置填空选项
    setInputAnswers(val) {
      console.log(val, val.answer);
      let correctAnswers = val.answers.map((item) => {
        return item.answer;
      });
      let correctAnswersStr = val.answers.map((item) => {
        return item.answer.join("或");
      });
      this.correctAnswers = correctAnswersStr.join(",");
      if (val.is_example) {
        let correctAnswer = val.answers[0].answer;
        this.inputAnswers = correctAnswer.map((item, index) => {
          return {
            text: item,
            correct: this.searchFlag(correctAnswers[index], item),
          };
        });
      } else if (val.answer) {
        let myAnswer = val.answer.split(",");
        console.log("myAnswer===", myAnswer);
        this.inputAnswers = myAnswer.map((item, index) => {
          return {
            text: item,
            correct: this.searchFlag(correctAnswers[index], item),
          };
        });
      } else {
        this.inputAnswers = val.answers.map((item) => {
          return {
            text: "",
            correct: false,
          };
        });
      }
      console.log(this.inputAnswers);
    },
    // 提交
    handleSubmit(index) {
      let correctAnswers = this.currItem.answers.map((item) => {
        return item.answer;
      });
      let userAnswer = this.inputAnswers.map((item) => {
        return item.text;
      });

      if (this.searchFlag(correctAnswers[index], userAnswer[index])) {
        this.$set(this.inputAnswers, index, {
          text: userAnswer[index],
          correct: true,
        });
      }

      let correctAnswersArray = this.inputAnswers.map((item) => {
        return item.correct;
      });
      let correctAnswersArraySet = correctAnswersArray.filter((item) => {
        return item;
      });

      let percentScore = (correctAnswersArraySet.length / this.inputAnswers.length) * this.currItem.score;
      // 作答的对象
      let ansObj = {
        questionId: this.currItem.index,
        answer: userAnswer.join(","),
        judge: this.isCorrect ? 1 : 0,
        scores: percentScore,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        // num: this.currItem.num,
        // nnum: this.currItem.nnum,
      };
      console.log(ansObj);
      // 选中后延时1s再提交
      this.$emit("saveRes", ansObj);
    },
    //输入框监听
    textInput(e, index) {
      this.$set(this.inputAnswers, index, { text: e.target.value });
      this.handleSubmit(index);
      if (!e.target.value) {
        this.showEditImg = true;
      }
    },
    //判断正确答案数组中是否包含书写的答案
    searchFlag(array, str) {
      let flag = array.find((item) => {
        return item == str;
      });
      return flag ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "pinyinFont";
  src: url("../../assets/font/pinyin.ttf");
}
.panel-content {
  width: 100%;
  padding: 110px 29px 0px 29px;
  position: relative;
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin-top: 0px;
  }
  .example {
    background: rgba(63, 70, 81, 1);
    border-radius: 4px;
    color: #fff;
    padding: 5px;
    font-size: 12px;
    position: absolute;
    top: 40px;
    left: 28px;
    min-width: 20px;
    display: flex;
    justify-content: center;
  }
  &-answer {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    padding-bottom: 80px;
    .answer-text {
      font-size: 15px;
      font-weight: 400;
      color: rgba(63, 70, 81, 1);
      line-height: 18px;
    }
    .pinyin-box {
      min-width: 70px;
    }
    .pinyin-text {
      font-size: 12px;
      font-family: "pinyinFont";
      color: rgba(185, 189, 192, 1);
      min-width: 70px;
      text-align: center;
    }
    .input-box {
      min-width: 70px;
      border-bottom: 1px solid #3f4651;
      padding-bottom: 0px;
      padding-top: 5px;
      input {
        border: none;
        font-size: 18px;
        color: #3f4651;
        font-weight: 500;
        width: 70px;
        text-align: center;
        background-color: #fff;
      }
    }
    .success {
      //border-bottom: 1px solid #09CBA0;
      input {
        color: #09cba0;
      }
    }
    .error {
      //border-bottom: 1px solid #FD943F;
      input {
        color: #fc5a5a;
      }
    }
  }
  &-result {
    padding: 40px 30px 20px 0;
    border-top: 1px dashed #e6eaef;
    width: 100%;
    &.result-error,
    &.result-correct {
      p.error-tips {
        font-size: 14px;
        color: #fc5a5a;
        margin-bottom: 20px;
      }
      p.correct-tips {
        font-size: 14px;
        color: rgba(9, 203, 160, 1);
        margin-bottom: 20px;
      }
      .result-show {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
      }
      .your-answer {
        font-size: 14px;
        font-weight: 500;
        color: rgba(84, 89, 97, 1);
        line-height: 14px;
        margin-right: 20px;
      }
      p.correct-answer {
        font-size: 14px;
        font-weight: 500;
        color: rgba(84, 89, 97, 1);
        line-height: 14px;
      }
      .correct-box {
        background: rgba(251, 252, 255, 1);
        border: 1px solid rgba(242, 243, 247, 1);
        border-radius: 10px;
        padding: 20px;

        &-title {
          font-size: 14px;
          font-weight: bold;
          color: rgba(63, 70, 81, 1);
          margin-bottom: 10px;
        }
        &-answer {
          font-size: 14px;
          font-weight: 400;
          color: rgba(84, 89, 97, 1);
          line-height: 21px;
          white-space: pre-line;
        }
      }
    }
  }
}
</style>
